module.exports = __webpack_public_path__ + "img/tatacliq.012c0a3b.png";